import Screen from '../../../../shared/utils/screen';
import styled from 'styled-components';

const SliderItemContainer = styled.div<React.CSSProperties>`
  border: ${5 * Screen.widthRatio}px solid transparent;
  cursor: pointer;
  float: left;
  height: ${428 * Screen.widthRatio}px;
  margin-right: ${3 * Screen.widthRatio}px;
  width: ${760 * Screen.widthRatio}px;
  &:hover {
    border: ${5 * Screen.widthRatio}px solid white;
    border-radius: ${36 * Screen.widthRatio}px;
  }
`;

export default SliderItemContainer;
